import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareSummaryEmbedRoute: InvariantJiraRoute = {
	name: 'software-summary-embed',
	path: '/jira/software/projects/:projectKey/summary/embed',
};
